import { createSlice } from "@reduxjs/toolkit";
import { appStorageKey, tenant } from "../utils/global";

const safeParse = (value) => {
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
};

const getStoredCompany = () => {
    const storedCompany = safeParse(localStorage.getItem(appStorageKey('selectedCompany')));
    if (storedCompany?.value) {
        return storedCompany;
    }
    return {
        name: tenant()?.companies[0].name[0].text || 'Select a company',
        value: tenant()?.companies[0]._id,
    };
};

const initialState = getStoredCompany();

const currentCompanySlice = createSlice({
    name: 'currentCompany',
    initialState,
    reducers:{
        setCurrentCompany: (state,action) => {
            state.name = action.payload.name;
            state.value = action.payload.value;
            state.updatedAt = Date.now();
            localStorage.setItem(appStorageKey('selectedCompany'), JSON.stringify({
                name: action.payload.name,
                value: action.payload.value,
                updatedAt: state.updatedAt
            }));
        }
    },
});

export const {setCurrentCompany} = currentCompanySlice.actions;
export default currentCompanySlice.reducer
